import FAQBase from "./FAQBase"

const BabySitterFAQs = () => {
  return <FAQBase title="BabySitter FAQs" faqType="BabySitter" />
}

export default BabySitterFAQs
